const marquees = document.querySelectorAll('[data-marquee-track]');

marquees.forEach((marquee) => {
  const allItems = marquee.querySelectorAll('[data-marquee-cell]');
  const speed = parseFloat(marquee.getAttribute('data-duration')) || 20;

  const direction = 'to-left';
  const directionVal = direction === 'to-left' ? -1 : 1;
  let totalX = 0;
  let marqueeH = 0;
  let animation;

  const adjustItems = () => {
    totalX = 0;
    marqueeH = 0;

    allItems.forEach((item) => {
      const itemW = item.offsetWidth;
      const itemH = item.offsetHeight;
      gsap.set(item, { x: totalX, width: itemW, height: itemH, willChange: 'transform' });
      totalX += itemW;
      if (itemH > marqueeH) {
        marqueeH = itemH;
      }
    });

    gsap.set([marquee], { height: marqueeH, xPercent: -50 });
    gsap.ticker.fps(30);
  };

  const createAnimation = () => {
    const stringX = `${directionVal === -1 ? '-' : '+'}=${totalX}`;

    return gsap.to(allItems, {
      repeat: -1,
      duration: speed,
      x: stringX,
      ease: 'none',
      paused: true,
      modifiers: {
        x(x, target) {
          if (directionVal === -1) {
            x = ((parseInt(x) - totalX) % totalX) + (totalX - target.offsetWidth);
          } else {
            x = parseInt(x) % totalX;
          }
          target.style.visibility = x > marquee.offsetWidth ? 'hidden' : 'visible';
          return `${x}px`;
        },
      },
    });
  };

  const initAnimation = () => {
    adjustItems();
    if (animation) {
      animation.kill();
    }
    animation = createAnimation();
    animation.play();
  };

  initAnimation();

  const debounceResize = debounce(() => {
    initAnimation();
  }, 300); // Increased debounce delay

  window.addEventListener('resize', debounceResize);
});
